/* Collapse/expand animations for SideNav.
 *
 * SideNav puts a <ViewTransition> around every row and names every section header, and SideNavPanel
 * animates its own width with a plain CSS transition so the rest of the page reflows along with it.
 * The two never run at the same time. */

::view-transition-group(.side-nav-item),
::view-transition-group(.side-nav-header) {
  animation-duration: 200ms;
  animation-timing-function: cubic-bezier(0.45, 0, 0.4, 1);
}

::view-transition-old(.side-nav-item),
::view-transition-new(.side-nav-item),
::view-transition-old(.side-nav-header),
::view-transition-new(.side-nav-header) {
  width: 100%;
  height: 100%;
}

:root:active-view-transition-type(
    side-panel-expand,
    side-nav-item-collapse,
    side-nav-item-expand
  ):global(::view-transition-old(root)) {
  animation: none;
  opacity: 0;
}

:root:active-view-transition-type(
    side-panel-expand,
    side-nav-item-collapse,
    side-nav-item-expand
  ):global(::view-transition-new(root)) {
  animation: none;
  mix-blend-mode: normal;
}

/* Expanding the panel puts section headers back into the layout, which pushes every row below them
 * down. A header comes back from display: none, so it has no box in the old state and enters rather
 * than moves. Holding that fade in until the second half keeps the header from appearing on top of
 * the rows that are still sliding past it. */
:root:active-view-transition-type(side-panel-expand)::view-transition-new(.side-nav-header) {
  animation-duration: 100ms;
  animation-delay: 100ms;
}
